import React from 'react';
import { useField } from 'react-final-form';

import { TextFieldsOutlined } from '@mui/icons-material';
import { InputLabel, Stack } from '@mui/material';

import RawSliderInput from '../raw/RawSliderInput';

function getValue(val: unknown): number {
  if (val === undefined || val === null) {
    return 0;
  }
  if (typeof val === 'string') {
    return parseInt(val.replace('px', ''));
  }
  return val as number;
}

type Props = {
  label: string;
  name: string;
};
export default function FontSize({ label, name }: Props) {
  const { input } = useField(name);
  const handleChange = (value: number) => {
    input.onChange(`${value}px`);
  };
  return (
    <Stack spacing={1} alignItems="flex-start">
      <InputLabel shrink>{label}</InputLabel>
      <RawSliderInput
        label={<TextFieldsOutlined sx={{ fontSize: 16 }} />}
        value={getValue(input.value)}
        onChange={handleChange}
        units="px"
        step={1}
        min={10}
        max={48}
      />
    </Stack>
  );
}
